import React from 'react';
import { Helmet } from 'react-helmet';
import { Loader, Dropdown } from 'semantic-ui-react';
import MediaQuery from 'react-responsive';

// Workspaces
// @ts-ignore
import { ErrorBoundary } from 'workspaces/redux-error-boundary';

// Global Components
// @ts-ignore
import CurrentSeasonInProgressGate from 'components/CurrentSeasonInProgressGate';
// @ts-ignore
import DatePagination from 'components/DatePagination';
// @ts-ignore
import ErrorBoundaryAlert from 'components/ErrorBoundaryAlert';
// @ts-ignore
import ErrorGate from 'components/ErrorGate';
import LoadingGate from 'components/LoadingGate';
import RoleButton from 'components/RoleButton';
import RoleGate from 'components/RoleGate';
import {
    ADMIN,
    MANAGER,
    ASSISTANT_MANAGER,
    PAYROLL
} from 'components/RoleGate/constants';
// @ts-ignore
import Online from 'components/Online';
// @ts-ignore
import PageTitleAndFilters from 'components/PageTitleAndFilters';
// @ts-ignore
import PageWrapper from 'components/PageWrapper';
import SelectedTableCellsBulkActionsDropdown from 'components/SelectedTableCellsBulkActionsDropdown';
import SelectedTableCellRowsClearDropdownItem from 'components/SelectedTableCellRowsClearDropdownItem';

// Child Components
import TimesheetUnapproveModal from 'scenes/Time/components/TimesheetUnapproveModal';
import TimesheetApproveModal from '../../components/TimesheetApproveModal';
import TimesheetDeleteModal from '../../components/TimesheetDeleteModal';
import TimesheetSubmitModal from '../../components/TimesheetSubmitModal';
// @ts-ignore
import CreateTimesheetModal from './components/CreateTimesheetModal';
import ExportTimesheetsModal from './components/ExportTimesheetsModal';
// @ts-ignore
import TimesheetsRequest from './components/TimesheetsRequest';
// @ts-ignore
import TimesheetsTable from './components/TimesheetsTable';
import GroupTimesheetModal from './components/GroupTimesheetModal';
import IndividualTimesheetModal from './components/IndividualTimesheetModal';
import SubmitMutipleTimesheetsDropdownItem from './components/SubmitMutipleTimesheetsDropdownItem';
import SubmitMultipleTimesheetModal from './components/SubmitMultipleTimesheetModal';
import ResetSelectedTableCellsOnUmnount from '../Timesheet/components/ResetSelectedTableCellsOnUmnount';

// Environment
const { REACT_APP_PROJECT_NAME } = process.env;

const Timesheets = (): React.ReactElement => (
    <RoleGate requiredRoles={[ADMIN, MANAGER, ASSISTANT_MANAGER, PAYROLL]}>
        <ErrorBoundary
            namespace="Timesheets"
            FallbackComponent={<ErrorBoundaryAlert />}
        >
            <Helmet>
                <title>
                    {'Timesheets - '}
                    {REACT_APP_PROJECT_NAME}
                </title>
            </Helmet>
            <Online>
                <TimesheetsRequest />
            </Online>
            <PageTitleAndFilters
                title="Timesheets"
                CustomSearch={<DatePagination />}
                datePicker
                Button={
                    <RoleButton
                        requiredRoles={[ADMIN, MANAGER, ASSISTANT_MANAGER]}
                        params={{
                            createTimesheetModal: true
                        }}
                        buttonProps={{
                            secondary: true
                        }}
                    >
                        Create Timesheet
                    </RoleButton>
                }
                FirstActionButton={
                    <RoleGate requiredRoles={[ADMIN, MANAGER]}>
                        <SelectedTableCellsBulkActionsDropdown
                            DropdownMenu={
                                <Dropdown.Menu>
                                    <SelectedTableCellRowsClearDropdownItem />
                                    <SubmitMutipleTimesheetsDropdownItem />
                                </Dropdown.Menu>
                            }
                        />
                    </RoleGate>
                }
                SecondActionButton={
                    <MediaQuery minWidth={1025}>
                        <RoleButton
                            requiredRoles={[ADMIN, PAYROLL]}
                            params={{
                                exportTimesheetsModal: true
                            }}
                            buttonProps={{
                                icon: false,
                                color: 'black',
                                basic: true
                            }}
                        >
                            Export
                        </RoleButton>
                    </MediaQuery>
                }
                currentEntity
                currentSeason
                group
                groupMultiple
                workType
                workTypeMultiple
                entity
                entityMultiple
                onlyMyTimesheets
            />
            <PageWrapper top={0} bottom={50}>
                <LoadingGate
                    namespace="TIMESHEETS_LOAD"
                    LoadingComponent={<Loader active inline="centered" />}
                >
                    <ErrorGate namespace="TIMESHEETS_LOAD">
                        <TimesheetsTable />
                    </ErrorGate>
                </LoadingGate>
            </PageWrapper>
            <ResetSelectedTableCellsOnUmnount />
            <CurrentSeasonInProgressGate>
                <CreateTimesheetModal />
                <ExportTimesheetsModal />
                <IndividualTimesheetModal />
                <GroupTimesheetModal />
            </CurrentSeasonInProgressGate>
            <SubmitMultipleTimesheetModal />
            <TimesheetUnapproveModal />
            <TimesheetApproveModal />
            <TimesheetDeleteModal />
            <TimesheetSubmitModal />
        </ErrorBoundary>
    </RoleGate>
);

export default Timesheets;
